import React from 'react'
import  "./Project.css"
//link 
import { Link } from 'react-router-dom'
//assets 
import project_image from "../../assets/project_img.png"

const Project = () => {
  return (
    <>
    <div className='projectimg'>
          <img src={project_image} alt="" />
        <div className='letter_overimg'>
           <p>Projects</p>
        </div>
    </div>
    <div className='phead'>
          <h1>project category</h1>
    </div>
    <hr />
   <div className='departments'>
   
      <p className='p1'><Link to="/projects/eee" className='spllink'>Electrical and electronics</Link></p>
      <p className='p2'><Link to="/projects/ece" className='spllink'>Electronics and communication</Link></p>
      <p className='p3'><Link to="/projects/mechanicalprojects" className='spllink'>Mechanical & mechatronics</Link></p>
      <p className='p4'><Link to="/projects/civil" className='spllink'>Civil eng</Link></p>
      <p className='p5'><Link to="/projects/web" className='spllink'>Web applications</Link></p>
      
   </div>
   <hr />
    <div className='chooseus'>
        <h1>About us</h1>
        <p>For over 8 years (since 2016),has been at the forefront of the IoT automation industry, 
           pioneering innovative solutions that transform how businesses operate. Our journey began with a
           simple yet powerful vision: to harness the power of the Internet of Things (IoT) to create smarter, 
           more efficient, and interconnected environments. we are a team of passionate engineers, developers, 
           and visionaries dedicated to pushing the boundaries of what is possible with IoT technology</p>
    </div>
    </>
  )
}

export default Project